import Header from "../Component/UserEnd/Header";
import ServiceTitle from "../Component/UserEnd/ServiceTitle";
import ServiceContent from "../Component/UserEnd/ServiceContent";
import Footer from "../Component/UserEnd/Footer";
function Service() {
  return (
    <>
      <Header />
      <ServiceTitle />
      <ServiceContent />
      <Footer />
    </>
  );
}

export default Service;
